import styled from "styled-components";
import { Range } from "react-range";
// import { device } from "src/theme/mediaQueries";

export const StyledRange = styled(Range)``;
